export enum PositionOperatorType {
  Higher,
  Lower,
  Equal,
}
